module.exports = __webpack_public_path__ + "static/media/strip-tablet-islands-desk.0147573f.png";